import { EllipsisHorizontalIcon } from '@heroicons/react/24/solid';
import React from 'react';

import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
} from '@/components/ui/catalyst/dropdown';

interface ActionsMenuProps {
  children: React.ReactNode;
  onKeyDown?: (e: React.KeyboardEvent<Element>) => void;
}

export const ActionsMenu = ({ children, onKeyDown }: ActionsMenuProps) => {
  const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  };

  return (
    <span
      onClick={stopPropagation}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={-1}
    >
      <Dropdown>
        <DropdownButton
          as="button"
          className="p-0.5 flex items-center justify-center rounded hover:bg-muted text-muted-foreground"
          onClick={(e) => e.stopPropagation()}
        >
          <EllipsisHorizontalIcon className="h-3.5 w-3.5" />
        </DropdownButton>
        <DropdownMenu>{children}</DropdownMenu>
      </Dropdown>
    </span>
  );
};

export default ActionsMenu;
